import React from "react";
import {OrderEditorTabProps} from "@widgets/pos/order/OrderEditor";
import {Alert, ButtonGroup, ButtonGroupButton, Icon} from "peggirkit";
import {ShoppingBagIcon, TruckIcon} from "@heroicons/react/20/solid";
import {FormattedMessage} from "react-intl";
import {useFormContext} from "react-hook-form";
import {PosOrderForm} from "@/data/entities/order";
import {useFulfillmentType} from "@widgets/pos/order/hooks/UseFulfillmentType";
import {emptyNewDeliveryAddress} from "@/data/entities/deliveryAddress";
import {useExistingOrder} from "@widgets/pos/order/hooks/UseExistingOrder";



const FulfillmentOptions = ({changeTabRef, isPending}: OrderEditorTabProps) => {
    const {setValue, getValues} = useFormContext<PosOrderForm>();
    const fulfillmentType = useFulfillmentType();
    const isLocked: boolean = useExistingOrder() !== null;
    const goToNextTab = () => {
        if (changeTabRef.current)
            changeTabRef.current(1);
    };
    const selectTakeaway = () =>
        setValue("deliveryAddress", {type: "TAKEAWAY"}, {shouldDirty: true});
    const selectDelivery = () => {
        // Keep an address that's already filled in
        if (getValues("deliveryAddress.type") !== "TAKEAWAY")
            return;

        // Existing customer: start with the first address of the account
        const firstAddress = getValues("customer")?.deliveryAddresses[0];
        setValue(
            "deliveryAddress",
            firstAddress ? {type: "EXISTING", id: firstAddress.id} : emptyNewDeliveryAddress(),
            {shouldDirty: true},
        );
    };

    console.log("isLocked", isLocked)

    return (
        <div className={"w-full flex items-start justify-center p-4"}>
            <div className={"mt-16 w-full max-w-[600px] flex flex-col gap-6 items-center justify-start"}>
                {
                    isLocked
                        ? <Alert
                            type={"warning"}
                            title={<FormattedMessage id={"fulfillmentLocked"}/>}
                            content={<FormattedMessage id={"fulfillmentLockedDescription"}/>}
                        />
                        : <Alert
                            type={"primary"}
                            title={<FormattedMessage id={"bewareOfChangingFulfillment"}/>}
                            content={<FormattedMessage id={"bewareOfChangingFulfillmentDescription"}/>}
                        />
                }


                <ButtonGroup>
                    <ButtonGroupButton
                        size={"lg"}
                        variant={"outline"}
                        iconBefore={<Icon icon={TruckIcon}/>}
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: (e) => {
                                    e.preventDefault();
                                    selectDelivery();
                                    goToNextTab();
                                },
                            },
                        }}
                        selected={fulfillmentType === "DELIVERY"}
                        disabled={isPending || (isLocked && fulfillmentType !== "DELIVERY")}
                    >
                        <FormattedMessage id={"delivery"}/>
                    </ButtonGroupButton>
                    <ButtonGroupButton
                        size={"lg"}
                        variant={"outline"}
                        iconBefore={<Icon icon={ShoppingBagIcon}/>}
                        buttonAction={{
                            as: "button",
                            actionProps: {
                                onClick: (e) => {
                                    e.preventDefault();
                                    selectTakeaway();
                                    goToNextTab();
                                },
                            },
                        }}
                        selected={fulfillmentType === "TAKEAWAY"}
                        disabled={isPending || (isLocked && fulfillmentType !== "TAKEAWAY")}
                    >
                        <FormattedMessage id={"takeaway"}/>
                    </ButtonGroupButton>
                </ButtonGroup>
            </div>
        </div>
    );
};

export default FulfillmentOptions;